import styled from "@emotion/styled";
import { PureComponent } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { isInIframe } from "helpers/app";
import { getEventDate, getFormattedEventDate } from "helpers/tickets";
import { EventType, IEvent } from "interfaces/entities/ticket";
import { wordWrap } from "styles/wordWrap";

import { ChildTicketOption } from "./ChildTicketOption";

interface IProps extends RouteComponentProps {
  date: Date;
  descriptionHtml: string;
  isMobile?: boolean;
  testId: string;
  event: IEvent;
}

interface IWrapper {
  isMobile?: boolean;
}

const Wrapper = styled.div<IWrapper>`
  margin: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isMobile ? "20px" : "40px 60px")
  };

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      !props.isMobile &&
      `
& + & {
margin-top: -32px;
}
`
  };
`;

const StyledMeta = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.43;

  a {
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.linkColor
    };
    text-decoration: none;
  }
`;

const StyledDescription = styled.div`
  flex: 1;
  font-size: 13px;
  padding-right: var(${SpacingToken.Spacing5});
  color: var(${DesignToken.ContentBasicSecondary});
  ${wordWrap};

  strong {
    font-weight: 600;
  }

  .rule-link {
    font-weight: 600;
  }
`;

const StyledDate = styled.div`
  font-size: 13px;
  color: var(${DesignToken.ContentBasicSecondary});
`;

const ChildTicketsFeedWrapper = styled.div`
  font-size: 15px;
`;

class RawTicketDescriptionEvent extends PureComponent<IProps> {
  descriptionRef: HTMLDivElement | null = null;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    const { history } = this.props;

    if (this.descriptionRef && !isInIframe()) {
      this.descriptionRef.addEventListener("click", event => {
        const target = event.target as Element;

        if (
          target &&
          ((target.nodeType === 1 && target.nodeName === "A" && target.getAttribute("class")) || "") === "rule-link"
        ) {
          // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
          history.push(target.getAttribute("href"));
          event.preventDefault();
        }
      });
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { date, descriptionHtml, isMobile, testId, event } = this.props;

    return (
      <>
        <Wrapper data-testid={testId} isMobile={isMobile}>
          <StyledMeta>
            <StyledDescription
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
              // FIXME: Fix this the next time the file is edited.
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ref={(c: any) => {
                this.descriptionRef = c;
              }}
            />
            <StyledDate title={getEventDate(date)}>{getFormattedEventDate(date)}</StyledDate>
          </StyledMeta>
        </Wrapper>
        {event.type === EventType.ChildTickets && (
          <ChildTicketsFeedWrapper>
            {/* @ts-expect-error TS(2532): Object is possibly 'undefined'. */}
            {event.childTickets.diff.map(item => (
              <ChildTicketOption key={item.ID} ticket={item} />
            ))}
          </ChildTicketsFeedWrapper>
        )}
      </>
    );
  }
}

export const TicketDescriptionEvent = withRouter(RawTicketDescriptionEvent);
